import { handleActions } from 'redux-actions';
import immutable from 'immutability-helper';
import { REHYDRATE } from 'redux-persist/lib/constants';
import { ActionTypes } from '../constants';



export const userState = {
    isAuthenticated: false,
    status: 'idle',
    response: '',
    redirect: '',
    is2FARequired: false,
    is2FAVerified: false,
    /* devices */
    deviceInitialized: false,
    deviceStatus: null,
    deviceMessage: null,
    notificationPermission: typeof Notification !== 'undefined' ? Notification.permission : 'default',
    deviceLoading: false,
    deviceError: null,
    /* logout state */
    logoutMessage: null,
    sessionExpired: false,
};


// eslint-disable-next-line import/no-anonymous-default-export
export default {
    authentication: handleActions(
        {
            [REHYDRATE]: (state, { payload }) => immutable(state, {
                redirect: { $set: null },
                isAuthenticated: {
                    $set:
                        payload && payload.authentication !== undefined
                            ? payload.authentication.isAuthenticated
                            : false
                },
                deviceStatus: {
                    $set: payload && payload.authentication !== undefined
                        ? payload.authentication.deviceStatus || {}
                        : {}
                },
            
                deviceInitialized: {
                    $set: payload && payload.authentication !== undefined
                        ? payload.authentication.deviceInitialized
                        : false
                },
                notificationPermission: {
                    $set: payload && payload.authentication !== undefined
                        ? payload.authentication.notificationPermission
                        : (typeof Notification !== 'undefined' ? Notification.permission : 'default')
                },
            }),

            [ActionTypes.USER_AUTH]: state => immutable(state, {
                status: { $set: 'running' },
                deviceLoading: { $set: true },
            }),
            [ActionTypes.USER_AUTH_FAILURE]: (state, { redirect, payload }) => immutable(state, {
                isAuthenticated: { $set: false },
                status: { $set: 'error' },
                response: { $set: payload },
                redirect: { $set: redirect },
                deviceLoading: { $set: false },
                deviceInitialized: { $set: false },
                deviceError: { $set: payload },
            }),

            [ActionTypes.USER_LOGIN_SUCCESS]: (state, { payload }) => immutable(state, {

                status: { $set: 'success' },
                response: { $set: payload },

                isAuthenticated: { $set: payload.requires2FA ? false : true },

                // True jika user HARUS masuk ke halaman 2FA
                is2FARequired: { $set: payload.requires2FA },

                // True jika 2FA sudah diverifikasi
                is2FAVerified: { $set: payload.twoFAVerified },

                // Redirect hanya jika user butuh 2FA
                redirect: { $set: payload.requires2FA ? '/2fa' : null },

                deviceInitialized: { $set: payload?.deviceInitialized || false },
                deviceLoading: { $set: false },
                deviceMessage: {
                    $set: payload?.deviceMessage || 'Device initialization pending'
                },
                deviceError: { $set: null },

            }),



            [ActionTypes.VERIFY_2FA_SUCCESS]: state => immutable(state, {
                status: { $set: 'success' },
                isAuthenticated: { $set: true },
                response: { $set: state.response }, // tetap pakai response lama
                is2FARequired: { $set: false },
                // Tandai 2FA sudah diverifikasi
                is2FAVerified: { $set: true },
                redirect: { $set: '/' },
                deviceLoading: { $set: false },
            }),

            /* ========== DEVICE ACTIONS ========== */
            [ActionTypes.DEVICE_INIT_REQUEST]: state => immutable(state, {
                deviceLoading: { $set: true },
                deviceMessage: { $set: 'Initializing device...' },
                deviceError: { $set: null },
            }),

            [ActionTypes.DEVICE_INIT_SUCCESS]: (state, { payload }) => immutable(state, {
                deviceInitialized: { $set: true },
                deviceStatus: { $set: payload.deviceStatus || {} },
                deviceMessage: { $set: payload.message || 'Device initialized successfully' },
                deviceLoading: { $set: false },
                deviceError: { $set: null },
            }),

            [ActionTypes.DEVICE_INIT_FAILURE]: (state, { payload }) => immutable(state, {
                deviceInitialized: { $set: false },
                deviceMessage: { $set: payload.message || 'Device initialization failed' },
                deviceLoading: { $set: false },
                deviceError: { $set: payload.error },
            }),

            [ActionTypes.DEVICE_LOGOUT_REQUEST]: state => immutable(state, {
                deviceLoading: { $set: true },
                deviceMessage: { $set: 'Logging out from device...' },
            }),

            [ActionTypes.DEVICE_LOGOUT_SUCCESS]: (state, { payload }) => immutable(state, {
                deviceInitialized: { $set: false },
                deviceStatus: { $set: payload.deviceStatus },
                deviceMessage: { $set: payload.message || 'Successfully logged out from device' },
                deviceLoading: { $set: false },
                notificationPermission: {
                    $set: typeof Notification !== 'undefined' ? Notification.permission : 'default'
                },
            }),

            [ActionTypes.DEVICE_LOGOUT_FAILURE]: (state, { payload }) => immutable(state, {
                deviceMessage: { $set: payload.message || 'Failed to logout from device' },
                deviceLoading: { $set: false },
                deviceError: { $set: payload.error },
            }),

            [ActionTypes.DEVICE_STATUS_REQUEST]: state => immutable(state, {
                deviceLoading: { $set: true },
            }),

            [ActionTypes.DEVICE_STATUS_SUCCESS]: (state, { payload }) => immutable(state, {
                deviceStatus: { $set: payload.deviceStatus },
                deviceLoading: { $set: false },
                deviceError: { $set: null },
            }),

            [ActionTypes.DEVICE_STATUS_FAILURE]: (state, { payload }) => immutable(state, {
                deviceMessage: { $set: payload.message || 'Failed to get device status' },
                deviceLoading: { $set: false },
                deviceError: { $set: payload.error },
            }),

            /* ========== NOTIFICATION PERMISSION ACTIONS ========== */
            [ActionTypes.REQUEST_NOTIFICATION_PERMISSION]: state => immutable(state, {
                deviceLoading: { $set: true },
                deviceMessage: { $set: 'Requesting notification permission...' },
            }),

            [ActionTypes.NOTIFICATION_PERMISSION_UPDATED]: (state, { payload }) => immutable(state, {
                notificationPermission: { $set: payload.permission },
                deviceLoading: { $set: false },
                deviceMessage: {
                    $set: payload.permission === 'granted'
                        ? 'Notification permission granted'
                        : 'Notification permission denied'
                },
            }),

            [ActionTypes.NOTIFICATION_PERMISSION_ERROR]: (state, { payload }) => immutable(state, {
                deviceLoading: { $set: false },
                deviceError: { $set: payload.error },
                deviceMessage: { $set: 'Failed to request notification permission' },
            }),

            /* ========== LOGOUT ACTIONS ========== */
            [ActionTypes.USER_LOGOUT]: state => immutable(state, {
                status: { $set: 'running' },
                deviceLoading: { $set: true },
                logoutMessage: { $set: 'Logging out...' },
            }),

            [ActionTypes.USER_LOGOUT_SUCCESS]: (state, { payload }) => immutable(state, {
                isAuthenticated: { $set: false },
                status: { $set: 'idle' },
                redirect: { $set: '/login' },
                response: { $set: '' },
                is2FARequired: { $set: false },
                is2FAVerified: { $set: false },
                deviceInitialized: { $set: false },
                deviceStatus: { $set: null },
                deviceMessage: { $set: null },
                deviceLoading: { $set: false },
                deviceError: { $set: null },
                notificationPermission: {
                    $set: typeof Notification !== 'undefined' ? Notification.permission : 'default'
                },
                logoutMessage: { $set: payload?.message || 'Logged out successfully' },
                sessionExpired: { $set: false },
            }),
            [ActionTypes.USER_LOGOUT_FAILURE]: (state, { payload }) => immutable(state, {
                isAuthenticated: { $set: true },
                status: { $set: 'idle' },
                deviceLoading: { $set: false },
                logoutMessage: { $set: payload?.message || 'Logout failed' },
                sessionExpired: { $set: false },
                // redirect: { $set: '/login' },
            }),
            /* ========== CLEAR DEVICE ERROR ========== */
            [ActionTypes.CLEAR_DEVICE_ERROR]: state => immutable(state, {
                deviceError: { $set: null },
                deviceMessage: { $set: null },
            }),
        },
        userState
    ),
};
